import Blue from "~/core";

new Blue({
	name: 'Search Header Input Transform',
	selector: ".search-header",
	setup(container) {
		const wrapper = container.querySelector(".search-header__input-wrapper");
		const input = container.querySelector("input.search-header__input");
		const cancel = container.querySelector(".search-header__cancel");
		this.$addEvents(input, "focusin", () => {
			wrapper.classList.add("input-active")
		})
		this.$addEvents(cancel, "click.prevent", () => {
			wrapper.classList.remove("input-active")
		})
	}
});